import React from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { ReduxState } from '../../types'

import styles from './styles.scss'
import { errorHandler } from '../../hoc'

interface Props {
  showModalLoader: boolean
}

export const ModalLoader: React.FunctionComponent<Props> = (props: Props) => {
  const classes = [styles.ModalLoader]
  props.showModalLoader && classes.push(styles.show)

  return <div className={classes.join(' ')} />
}

export default compose(
  errorHandler('containers/ModalLoader/ModalLoader.tsx'),
  connect((state: ReduxState) => ({
    showModalLoader: !!state.modalLoader.ids.length,
  }))
)(ModalLoader)
